var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"baseInput"},[_c('input',{ref:"input",staticClass:"baseInput__input",attrs:{"placeholder":_vm.placeholder,"disabled":_vm.disabled,"type":_vm.inputType},domProps:{"value":_vm.value},on:{"input":_vm.inputHandler,"focus":_vm.focusHandler}})])
}
var staticRenderFns = []

export { render, staticRenderFns }